import React from "react";
import {styled, theme} from "@reside/ui";
import {BulkAssignmentVariant} from "./bulkPermissions.helpers";

export const PermissionsBulkStatusLegend = () => (
  <Root aria-label="Permission status legend">
    <LegendLabel>Legend:</LegendLabel>
    <LegendItem $tone={BulkAssignmentVariant.All}>
      {BulkAssignmentVariant.All} N
      <span className="description"> = All users have it</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone={BulkAssignmentVariant.Partial}>
      X of N
      <span className="description"> = {BulkAssignmentVariant.Partial}</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone={BulkAssignmentVariant.None}>
      {BulkAssignmentVariant.None}
      <span className="description"> = No users have it</span>
    </LegendItem>
    <Separator>·</Separator>
    <LegendItem $tone={BulkAssignmentVariant.Pending}>
      ({BulkAssignmentVariant.Pending})
      <span className="description"> = Unsaved change</span>
    </LegendItem>
  </Root>
);

const Root = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

const LegendLabel = styled.span`
  color: ${theme.color.darkBlue100};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

const LegendItem = styled.span<{
  $tone: BulkAssignmentVariant;
}>`
  color: ${({$tone}) =>
    $tone === BulkAssignmentVariant.All
      ? theme.color.green100
      : $tone === BulkAssignmentVariant.Partial
      ? theme.color.orange100
      : theme.color.gray100};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  .description {
    color: ${theme.color.gray150};
    font-weight: 400;
  }
`;

const Separator = styled.span`
  color: ${theme.color.gray100};
  font-size: 14px;
  line-height: 20px;
`;
